/**
 * Makes jQuery available globally and installs jquery-migrate since some WP plugins need it.
 * In functions.php we exclude the jquery WordPress normally provides.
 */

declare const $: JQueryStatic;
window.$ = jQuery;

// Import jquery-migrate
($ as any).migrateMute = true; // Disable jQuery migrate logging

// Add jQuery as a global
declare global {
	interface Window {
		jQuery: JQueryStatic;
		$: JQueryStatic;
	}
}
window.$ = $;

export default $;
